import { render } from "./ChatBotApp.vue?vue&type=template&id=67c0bcc2&scoped=true"
import script from "./ChatBotApp.vue?vue&type=script&lang=js"
export * from "./ChatBotApp.vue?vue&type=script&lang=js"

import "./ChatBotApp.vue?vue&type=style&index=0&id=67c0bcc2&scoped=true&lang=css"
import "./ChatBotApp.vue?vue&type=style&index=1&id=67c0bcc2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67c0bcc2"]])

export default __exports__